export default "__VITE_ASSET__013e79eb__"